<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/HumanResources/VISAs"
        >Human Resources</b-breadcrumb-item
      >
      <b-breadcrumb-item to="/HumanResources/VISAs">VISAs</b-breadcrumb-item>
      <b-breadcrumb-item active>{{ personName }}</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="card">
      <div class="bg-dark card-header text-white">Edit VISA Information</div>
      <div class="card-body">
        <h4>({{ personUIN }}) {{ personName }}</h4>
        <div class="card">
          <div class="card-header">
            <ul class="card-header-tabs nav nav-tabs">
              <li class="nav-item">
                <a
                  @click="currentTabComponent = 'TheVisaGeneralInfoForm'"
                  class="active nav-link"
                  data-toggle="tab"
                  href="#"
                  >General</a
                >
              </li>
              <li class="nav-item">
                <a
                  @click="currentTabComponent = 'TheVisaNotesList'"
                  class="nav-link"
                  data-toggle="tab"
                  href="#"
                  >Notes</a
                >
              </li>
              <li class="nav-item">
                <a
                  @click="currentTabComponent = 'TheVisaAttachmentList'"
                  class="nav-link"
                  data-toggle="tab"
                  href="#"
                  >Attachments</a
                >
              </li>
            </ul>
          </div>
          <div id="tab-container">
            <keep-alive>
              <component :is="currentTabComponent" :id="id" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheVisaGeneralInfoForm from "@/components/visas/TheVisaGeneralInfoForm.vue";
import TheVisaNotesList from "@/components/visas/TheVisaNotesList.vue";
import TheVisaAttachmentList from "@/components/visas/TheVisaAttachmentList.vue";

export default {
  components: {
    TheVisaGeneralInfoForm,
    TheVisaNotesList,
    TheVisaAttachmentList
  },
  data() {
    return {
      id: null,
      currentTabComponent: "TheVisaGeneralInfoForm",
    };
  },
  props: {
    personName: {
      type: String,
      required: false,
    },
    personUIN: {
      type: String,
      required: false,
    },
  },
  created() {
    this.id = this.$route.params.id;
  },
};
</script>
